export default __webpack_public_path__ + "static/media/tick-yellow.b9a056bd.svg";